import CheckBox from 'components/checkbox'
import Header from 'components/header'
import SideBar from 'components/siderbar'
import { NotificationContext } from 'context/notification_context'
import React, { useContext, useEffect, useState } from 'react'
import { Button, ListGroup } from 'react-bootstrap'
import { BsCheck, BsTrash } from 'react-icons/bs'
import { MdArrowBack, MdClose, MdDelete, MdEdit } from 'react-icons/md'
import { useNavigate, useParams } from 'react-router'
import { Service } from 'services/api'
import Renderif from 'utils/renderif'

export default function AnswersView() {
    const navigate = useNavigate()

   const {id_activity, id_question} = useParams()
    
   const {notify} = useContext(NotificationContext)
    const [file, setFile] = useState({
        path:null,
        file:null
    })

    const [state, setState] = useState({
        question:null,
        activity:null,
 
        answer:{
            answer:"",
            image:"Image",
        },
        answers:[],

        
    })

    useEffect(()=>{
        init()
        return () => {}
    },[])

    useEffect(()=>{
        console.log(file?.name)
    },[file])

    const init = async () => {

        let _activity = await Service('GET', `activity/${id_activity}`)
        console.log(_activity.data.data.questions)
        state.questions = _activity.data.data.questions
        state.activity = _activity.data.data

        loadQuestion(id_question)


       file.path = null
       file.file = null
        setState({...state})

    }



    const onCreateAnswer = async () => {
        
        let body = {
            ...state.answer
        }
        body.idQuestion = state.idQuestion
        
        if(file !== null){
            let _upload = await upLoad()
            body.image = _upload.data;
        }

        console.log(body)

        let _create_answer = await Service('POST', `answer`, body)

        if(_create_answer.status === 201){
            notify({title:"Respuesta", message:"Respuesta creada exitosamente.", type:'success'})
        }else{
            notify({title:"Nueva pregunta", message:"", type:'error'})
        }
  
        state.answer.answer=""
        state.answer.image="Image"

        
    
        // loadQuestion(state.idQuestion)
        init();

    }

    const loadQuestion = async (id_question) => {
        let _question = await Service('GET', `question/${id_question}`)
        console.log(_question.data.data)
        state.idQuestion = id_question
        state.question = _question.data.data
        state.answers = _question.data.data.options
        state.step = 1
        setState({...state})
    }

    const upLoad = async () => {
        
        let body = new FormData();
        body.append("file", file.file);
        return await Service('POSTMEDIA', `upload`, body )
        
        // return await Service('POSTMEDIA', `document/upload/${type}`, body )

        // let _upload = await Service('POSTMEDIA', 'upload') 
    } 

    const markascorrect = async (idAnswer) => {
        let body = {
            idAnswer
        }
        let _question_update = await Service('PATCH', `question/${state.question.id}`, body)
        if(_question_update.status === 200){
            notify({title:"Respuesta", message:"Respuesta ha sido marcada como correcta exitosamente.", type:'success'})
        }
        
        init()

    }
    const onDeleteAnswer = async (idAnswer) => {
        let _delete_answer = await Service('DELETE', `answer/${idAnswer}`)
        if(_delete_answer.status === 200){
            notify({title:"Eliminar respuesta", message:"Respuesta ha sido eliminada.", type:'success'})
        }
 
        init();
    }

    const readURL = file => {
        return new Promise((res, rej) => {
            const reader = new FileReader();
            reader.onload = e => res(e.target.result);
            reader.onerror = e => rej(e);
            reader.readAsDataURL(file);
        });
    };
  return (
    <div className='container-fluid d-flex p-0'>
        <SideBar></SideBar>
        

        <div className='col overflow-auto'>
    
            <Header showback={true} title={state.activity?.name} subtitle="Dinámica" />



     



               <div className='container-md mt-5'>

                    <div className='d-flex align-items-center bg-white-alpha-05 overflow-hidden r-10'>
                    
                        <div className='thumbnail--sm' style={{backgroundImage: `${state.question?.image === null ? 'url(/images/dinamica_name.jpeg)' : `url(${state.question?.image})` }`}}></div>

                        <div className='col px-3'>
                            <div className='f-22 bold'>{state.question?.question}</div>
                            <div className='f-16 bold'>{state.activity?.name}</div>
                            {/* <div className='f-22 bold'>{state.activity?.status}</div> */}
                            {/* <div className={`tag tag--${state.activity?.status === true ? 'green' : 'gray'}`}>{getStatus(state.activity?.status)}</div> */}
                            
                        </div>
                       
                    </div>

                </div>

             

          

  
                <div className='container-md mt-3'>
                    <div className='bg-white-alpha-05 r-10 px-3 py-1'>
                        <div>
                            <div className='f-14 bold my-1'>Escribe una respuesta</div>
                            <input className='form-control' value={state.answer.answer} onChange={(evt)=>{
                                state.answer.answer = evt.currentTarget.value
                            
                                setState({...state})
                            }}></input>
                        </div>


                        <div>
                            <div className='f-14 bold my-1'>Agrega una imagen a tu respuesta {file?.name}</div>
                            <input type='file' className='form-control' value="" placeholder='' onChange={async (evt)=>{
                

                                // var reader = new FileReader();
                                // reader.onload = function (e) {
                                //     console.log(e.target.result)
                                // }
                                // reader.readAsDataURL(evt.currentTarget.files[0]);
                                console.log(URL.createObjectURL(evt.currentTarget.files[0]))
                                
                                file.path = URL.createObjectURL(evt.currentTarget.files[0])
                                file.file = evt.currentTarget.files[0]
                                setFile({...file})
                            }}></input>

                        <div className='my-2'>
                            <img width={200} className='r-10' src={file?.path}></img>
                        </div>

                        </div>


                        <div className=''>
                            <Button onClick={()=>{
                            onCreateAnswer()
                            }}>
                                + Respuesta
                            </Button>
                        </div>

                        <table className='table r-5 overflow-hidden mt-3'>
                            <thead>
                                <tr>
                                    <th className='f-14 bold'>Image</th>
                                    <th className='f-14 bold'>Respuesta</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {state.answers.map((answer, i)=>{
                                    return (
                                        <tr>
                                            <td>
                                                <Renderif isTrue={answer.image !== "" && answer.image !== null}>
                                                    <img alt='' width={40} src={answer.image}></img>
                                                </Renderif>
                                            </td>
                                            <td>{answer.answer}</td>
                                            <td>
                                              <div className='d-flex'>

                                                <Renderif isTrue={state.question.idAnswer !== answer.id}>
                                                    <div className='icon bg-gray cursor-pointer' onClick={()=>{
                                                        markascorrect(answer.id)
                                                    }}>
                                                    
                                                        <MdClose size={20} color='#aaa'></MdClose>
                                                    </div>
                                                </Renderif>

                                                <Renderif isTrue={state.question.idAnswer === answer.id}>
                                                    <div className='icon bg-primary'>
                                                        <BsCheck size={20}></BsCheck>
                                                    </div>
                                                </Renderif>
                                                    <div className='icon bg-gray cursor-pointer' onClick={()=>{
                                                        onDeleteAnswer(answer.id)
                                                    }}>
                                                        <MdDelete size={20} color='#DF2222'></MdDelete>
                                                    </div>

                                              </div>

                                             
                                            </td>
                                        </tr>
                                    )
                                })}
                    
                            </tbody>
                        </table>

                    </div>

                </div>

             


        

            


            
     

        </div>

    </div>
  )
}
